function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Service from '@ember/service';
import { set } from '@ember/object';
export default class AppointmentsMarketContextService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "increaseMarketZIndex", false);
  }
  /**
   * Glass UI modals in Dashboard open in a different context than Market modals. Because of this,
   * using both types of modals at the same time will result in one not rendering on top correctly.
   * This workaround dynamically changes the z-index of the market-context-manager to greater than the
   * z-index of the Glass UI modals so Market modals can render on top correctly.
   *
   * See frontend/@square/appointments-feature-upsell/addon/styles/addon.scss for the CSS style that
   * controls the z-index
   *
   * See frontend/dashboard/app/templates/application.hbs for where it's applied
   */
  setIncreaseMarketZIndex(increaseMarketZIndex = false) {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    set(this, 'increaseMarketZIndex', increaseMarketZIndex);
  }
}